import { render } from "./MensShoes.vue?vue&type=template&id=4a8f688e"
import script from "./MensShoes.vue?vue&type=script&lang=js"
export * from "./MensShoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__